import { createContext, useContext, type ReactNode } from "react";
import { useBrand } from "../branding/BrandContext";
import { useTheme, type Theme } from "../hooks/useTheme";

const ThemeContext = createContext<{ theme: Theme; toggle(): void } | null>(null);

export function ThemeProvider({ children }: { children: ReactNode }) {
  const value = useTheme(useBrand().checkout.defaultTheme);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useThemeContext() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useThemeContext outside <ThemeProvider>");
  return ctx;
}
